import React from 'react';
import { Box, Button, Container, Heading, Text, VStack, Alert, AlertIcon, AlertTitle, AlertDescription, useToast } from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';
import { sendEmailVerification } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';

export default function EmailNotVerified() {
  const { currentUser } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();

  const handleResend = async () => {
    if (!currentUser) return;
    try {
      await sendEmailVerification(auth.currentUser);
      toast({
        title: '確認メール送信',
        description: 'メール確認用のメールを送信しました。',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: 'エラー',
        description: '確認メールの送信に失敗しました。',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  // ログアウト処理
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      toast({
        title: 'ログアウト失敗',
        description: 'ログアウト処理中にエラーが発生しました。',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Box minH="100vh" bg="gray.50" py={10} display="flex" alignItems="center" justifyContent="center">
      <Container maxW="md">
        <Box bg="white" p={8} borderRadius="lg" boxShadow="lg">
          <VStack spacing={6}>
            <Alert status="warning">
              <AlertIcon />
              <Box>
                <AlertTitle>メール認証が必要です</AlertTitle>
                <AlertDescription>
                  ご登録のメールアドレスはまだ認証されていません。<br />
                  メール内のリンクをクリックして認証を完了してください。<br />
                  <Text mt={2} fontSize="sm" color="gray.600">
                    ※ 確認メールが届かない場合は、迷惑メールフォルダもご確認ください。
                  </Text>
                </AlertDescription>
              </Box>
            </Alert>
            <Button bg="black" color="white" w="full" onClick={handleResend}>
              確認メールを再送信
            </Button>
            <Button bg="black" color="white" w="full" onClick={handleLogout}>
              ログアウト
            </Button>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
} 